module.exports = __webpack_public_path__ + "static/042.thumb-1ae26c64c580fd656ed982e0e98c25d5.jpg";